import { createAction } from 'redux-actions';
import * as phraseTRFormTypes from './phraseTRFormTypes';

export const addTranslation = createAction(phraseTRFormTypes.ADD_TRANSLATION);
export const changeTranslation = createAction(phraseTRFormTypes.CHANGE_TRANSLATION);
export const onSaveButtonClick = createAction(phraseTRFormTypes.SAVE_BUTTON_CLICK);
export const loadForm = createAction(phraseTRFormTypes.LOAD_FORM);
export const onDeleteButtonClick = createAction(phraseTRFormTypes.DELETE_BUTTON_CLICK);
